import type { Settlement } from '../engine/map/settlement';
import { recordConsumed } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runIndependentProductionTick } from './genericProduction';

export function runFarmTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    const toolUsage = config.production.farm.toolUsage;
    const workerCount = Math.min(settlement.jobs.farmers, settlement.tools.farmers.length);
    let changed = runIndependentProductionTick(
        settlement,
        'farm',
        workerCount,
        settlement.production.farm.progress,
        config.production.farm.ticksPerFarmer,
    );

    for (let i = settlement.tools.farmers.length - 1; i >= 0; i -= 1) {
        settlement.tools.farmers[i].durability -= toolUsage;
        if (settlement.tools.farmers[i].durability <= 0) {
            recordConsumed(settlement, 'tools', 1);
            settlement.tools.farmers.splice(i, 1);
            changed = true;
        }
    }

    return changed;
}
